import { styled } from "@mui/material/styles";

export const CaptionsText = styled("div")<{ fontSize: string }>(({ theme, fontSize }) => ({
  padding: theme.spacing(2),
  color: theme.custom.palette.white,
  fontSize: fontSize,
  textAlign: "center",
  width: "100%",
  height: "118px",
  zIndex: 998,
  background: theme.custom.palette.black,
  whiteSpace: "pre-line",
}));
